export default {
  title: 'How are the shares divided?',
  number_of_shares: 'Value per share',
  description:
    'Usually 120 shares are issued when a BV is incorporated, because this is an easily divisible number by multiple shareholders. However, you can always choose to deviate from this.',
  shareholders: 'Shareholders(s)',
  warning:
    'When incorporating a company with a high share capital, the notary is required to carry out additional work. For example, starting from a share capital of €10,000, the notary has a legal duty to investigate the origin of the funds. Because this involves a customized process, it is not possible to incorporate a B.V. via Ligo with a share capital higher than €10,000. For more information, feel free to contact us at 020-3031043.'
};
